import type { MetaFile } from "../base/MetaFile"
import type { VirtualFile } from "../VirtualFile"
import type { VirtualFileType } from "../VirtualFileType"
import type { GeneratedFile } from "./GeneratedFile"
import type { RemoteFile } from "./RemoteFile"

export type ZipFile = {
  readonly enum: VirtualFileType.ZIP_FILE
  readonly content: GeneratedFile | RemoteFile
  readonly files: Record<string, VirtualFile>
} & MetaFile
